// extracted by mini-css-extract-plugin
export var videoHero = "_ds-4";
export var videoHeroImage = "_ds-5";
export var videoHeroOverlay = "_ds-6";
export var videoHeroSubtitle = "_ds-8";
export var videoHeroText = "_ds-7";
export var videoLauncher = "_ds-0";
export var videoLauncherIcon = "_ds-1";
export var videoLauncherSubtitle = "_ds-3";
export var videoLauncherTitle = "_ds-2";
export var videoPlayer = "_ds-a";
export var videoPlayerWrap = "_ds-9";